import { render, staticRenderFns } from "./TraderInfo.vue?vue&type=template&id=cb7795fe&"
import script from "./TraderInfo.vue?vue&type=script&lang=ts&"
export * from "./TraderInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports